import { useUserSettingsStore } from "@/stores/UserSettings";
import { useGenresStore } from "@/stores/Genres";
import { storeToRefs } from 'pinia';

export default defineNuxtRouteMiddleware(() => {
	const GenresStore = useGenresStore();
	const {
		getTotalCount,
	} = storeToRefs(GenresStore);
	const { fetchGenres } = GenresStore;

	const UserSettingsStoreModule = useUserSettingsStore();
	const {
		isCraveAvailable: hasCrave,
	} = storeToRefs(UserSettingsStoreModule);

	if (import.meta.client) {
		const isLoadedGenres: boolean = getTotalCount.value > 0 ? true : false;

		if (!isLoadedGenres) {
			void fetchGenres(hasCrave.value);
		}
	}
});